"use strict";

define('view/table.flag',['require','exports','module','underscore','backbone','uikit/uikit','marionette','model/flag','../templates'],function (require, exports, module) {
  var _ = require('underscore');
  var Backbone = require('backbone');
  var UIKit = require('uikit/uikit');
  var Mn = require('marionette');
  var Flag = require('model/flag');
  var Templates = require('../templates');
  var FlagsTableHeaderCellView = UIKit.Table.HeaderCellView.extend({
    template: Templates.IRB['flags.table.header']
  });
  module.exports = UIKit.Table.extend({
    attributes: {
      role: 'presentation'
    },
    headerCellView: FlagsTableHeaderCellView,
    options: {
      sortable: false,
      selectable: true,
      selection: 'multi',
      toggleSelection: true,
      category: null,
      columns: null,
      availableFlags: null,
      studyFlags: null
    },
    CLASSNAME_SAVED: 'saved',
    CLASSNAME_SAVE_PENDING: 'save-pending',
    CLASSNAME_REMOVAL_PENDING: 'removal-pending',
    CUSTOM_ROW_INDEX: 'id',
    FLAG_ARIA_LABEL_SUFFIXES: {
      'saved': ', selected',
      'save-pending': ', selected, unsaved',
      'removal-pending': ', removing, unsaved'
    },
    _dirty: false,
    _adjustClasses: function _adjustClasses(view, classesOn) {
      var possibleClasses = [this.CLASSNAME_SAVED, this.CLASSNAME_SAVE_PENDING, this.CLASSNAME_REMOVAL_PENDING];
      _.each(possibleClasses, view.$el.removeClass, view.$el);
      _.each(classesOn, view.$el.addClass, view.$el);
    },
    _getClassesToAdd: function _getClassesToAdd(saved, selected) {
      var classesToAdd = [];
      if (saved && !selected) {
        classesToAdd.push(this.CLASSNAME_REMOVAL_PENDING);
      } else if (!saved && selected) {
        classesToAdd.push(this.CLASSNAME_SAVE_PENDING);
      } else if (saved && selected) {
        classesToAdd.push(this.CLASSNAME_SAVED);
      }
      return classesToAdd;
    },
    _getRowARIALabel: function _getRowARIALabel(rowView, saved, selected) {
      var flagCategory = this.columns.first().get('text');
      var ariaLabel = flagCategory + ': ' + rowView.model.get('description');
      return ariaLabel += selected && saved ? this.FLAG_ARIA_LABEL_SUFFIXES['saved'] : selected && !saved ? this.FLAG_ARIA_LABEL_SUFFIXES['save-pending'] : !selected && saved ? this.FLAG_ARIA_LABEL_SUFFIXES['removal-pending'] : '';
    },
    _setRowARIALabel: function _setRowARIALabel(rowView, saved, selected) {
      var ariaLabel = this._getRowARIALabel(rowView, saved, selected);
      rowView.updateElementAttributes({
        'aria-label': ariaLabel
      });
      if (rowView.shouldAnnounce) {
        this.announce(ariaLabel);
      }
      rowView.shouldAnnounce = false;
    },
    announce: function announce(message) {
      this.announcer.textContent = message;
    },
    _tableSelectionsMatchesOriginalSelections: function _tableSelectionsMatchesOriginalSelections() {
      return _.isEqual(this._originalSelections.models, this.value.sort().models);
    },
    _markRow: function _markRow(rowView, saved, selected) {
      var classesToAdd = this._getClassesToAdd(saved, selected);
      rowView.model.saved = saved;
      rowView.model.selected = selected;
      this._dirty = saved === selected ? !this._tableSelectionsMatchesOriginalSelections() : true;
      this._adjustClasses(rowView, classesToAdd);
      this._setRowARIALabel(rowView, saved, selected);
    },
    _markRowPendingRemoval: function _markRowPendingRemoval(rowView) {
      this._markRow(rowView, true, false);
    },
    _markRowPendingSave: function _markRowPendingSave(rowView) {
      this._markRow(rowView, false, true);
    },
    _markRowSaved: function _markRowSaved(rowView) {
      this._markRow(rowView, true, true);
    },
    _unmarkRow: function _unmarkRow(rowView) {
      this._markRow(rowView, false, false);
    },
    _markDeselectedRowByModel: function _markDeselectedRowByModel(deselectedModel) {
      var rowView = this.getRow(deselectedModel);
      if (rowView && rowView.model.saved) {
        this._markRowPendingRemoval(rowView);
      } else if (rowView) {
        this._unmarkRow(rowView);
      }
    },
    _markSelectedRowByModel: function _markSelectedRowByModel(selectedModel) {
      var rowView = this.getRow(selectedModel);
      if (rowView && this._originalSelections.findWhere(rowView.model.attributes)) {
        this._markRowSaved(rowView);
      } else if (rowView) {
        this._markRowPendingSave(rowView);
      }
    },
    getRows: function getRows(collection) {
      if (this.children._indexByCustom && !_.isEmpty(this.children._indexByCustom) && collection instanceof Backbone.Collection) {
        return collection.map(function (model) {
          return this.children.findByCustom(model.get(this.CUSTOM_ROW_INDEX));
        }, this);
      }
    },
    _getValidRows: function _getValidRows(modelCollection) {
      return _.filter(this.getRows(modelCollection), function (row) {
        return !!row;
      });
    },
    _getValidRowsFromArray: function _getValidRowsFromArray(modelArray) {
      return this._getValidRows(new Backbone.Collection(modelArray));
    },
    _findModelInCollectionByCustomIndex: function _findModelInCollectionByCustomIndex(collection, model) {
      var searchAttrs = {};
      searchAttrs[this.CUSTOM_ROW_INDEX] = model[this.CUSTOM_ROW_INDEX];
      return collection.findWhere(searchAttrs);
    },
    _findMatchingCollectionModelsByCustomIndex: function _findMatchingCollectionModelsByCustomIndex(originalSelectedModels) {
      return _.reduce(originalSelectedModels, function (matches, model) {
        var collectionInstance = this._findModelInCollectionByCustomIndex(this.collection, model);
        if (collectionInstance) matches.push(collectionInstance);
        return matches;
      }, [], this);
    },
    _resetTableRows: function _resetTableRows() {
      var selections = this.value;
      var rowsToMarkSaved = this._getValidRows(selections);
      _.each(rowsToMarkSaved, this._markRowSaved, this);
      var rowsToUnmark = this._getValidRowsFromArray(this.collection.filter(function (model) {
        return !this._findModelInCollectionByCustomIndex(selections, model);
      }, this));
      _.each(rowsToUnmark, this._unmarkRow, this);
    },
    _resetTableSelections: function _resetTableSelections() {
      var collectionInstances = this._findMatchingCollectionModelsByCustomIndex(this.getOption('studyFlags'));
      this.value.reset(collectionInstances);
      this._originalSelections = this.value.clone().sort();
      this._dirty = false;
      this._resetTableRows();
    },
    _initTableListeners: function _initTableListeners() {
      this.listenTo(this.availableFlags, 'sync', this.refreshCollection);
      this.listenTo(this.value, 'add', this._markSelectedRowByModel);
      this.listenTo(this.value, 'remove', this._markDeselectedRowByModel);
    },
    _initTableSelections: function _initTableSelections() {
      this.value = new Flag.Collection();
    },
    _initCustomViewIndex: function _initCustomViewIndex() {
      _.each(this.children._views, function (view) {
        this.children._indexByCustom[view.model.get(this.CUSTOM_ROW_INDEX)] = view.cid;
      }, this);
    },
    _isolateCategoryWithinCollection: function _isolateCategoryWithinCollection(flagCollection, category) {
      flagCollection.remove(flagCollection.filter(function (flag) {
        return flag.get('category') !== category;
      }));
    },
    _initCollectionByCategory: function _initCollectionByCategory() {
      if (this.availableFlags instanceof Backbone.Collection) {
        this.collection = this.availableFlags.clone();
        this._isolateCategoryWithinCollection(this.collection, this.getOption('category'));
      }
    },
    initialize: function initialize() {
      UIKit.Table.prototype.initialize.apply(this, arguments);
      this._initCollectionByCategory();
      this._initTableSelections();
      this._initTableListeners();
    },
    isDirty: function isDirty() {
      return !!this._dirty;
    },
    getSelectedFlags: function getSelectedFlags() {
      return this.value.models;
    },
    onRenderCollection: function onRenderCollection() {
      this._initCustomViewIndex();
      this._resetTableSelections();
    },
    onRender: function onRender() {
      UIKit.Table.prototype.onRender.apply(this, arguments);
      var self = this;
      _.defer(function () {
        self.announcer = document.getElementById('flagsAnnouncer');
      });
    },
    onRowPress: function onRowPress(rowView) {
      var flagModel = rowView.model;
      rowView.shouldAnnounce = true;
      if (this.isSelected(flagModel)) {
        this.value.remove(flagModel);
      } else {
        this.value.push(flagModel);
      }
    },
    refreshCollection: function refreshCollection() {
      this._initCollectionByCategory();
    },
    removeChildView: function removeChildView() {
      Mn.CompositeView.prototype.removeChildView.apply(this, arguments);
    },
    resetStudyFlags: function resetStudyFlags(studyFlags) {
      this.options.studyFlags = studyFlags;
      this._resetTableSelections();
    }
  });
});

